export const getUserPreferences = ({ currentUser }) => {
  try {
    if (Object.prototype.hasOwnProperty.call(currentUser, "preferences")) {
      return typeof currentUser.preferences === "string"
        ? JSON.parse(currentUser.preferences)
        : currentUser.preferences;
    }
  } catch (error) {
    return null;
  }
};
